import { useState } from "react";
import { Modal } from "react-bootstrap";
import { Button } from "components/Button";
import { SubmitButton } from "components/Button/SubmitButton";
import { useEquipmentDetails } from "./useEquipmentDetails";
import { EquipmentListItem } from "types/EquipmentListItem";

export const EquipmentDeleteModal: React.FC<{
    show: boolean;
    onHide: () => void;
    applicationNumber: string | undefined;
    onEquipmentDelete?: (equipmentNumber: string, hasApprovedMeasure?: boolean) => void | Promise<void>;
    equipment?: EquipmentListItem;
}> = ({ show, onHide, applicationNumber, onEquipmentDelete, equipment }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [equipmentDetails] = useEquipmentDetails(applicationNumber, equipment?.equipid);

    const deleteEquipment = async (equipmentNumber?: string) => {
        const hasApprovedMeasure = equipmentDetails?.attributes?.some((attr: { hasApproveMeasure?: boolean }) => attr.hasApproveMeasure);
        if (equipmentNumber && onEquipmentDelete) {
            setIsSubmitting(true);
            try {
                await onEquipmentDelete(equipmentNumber, hasApprovedMeasure);
                onHide();
            } finally {
                setIsSubmitting(false);
            }
        } else {
            onHide();
        }
    };

    return (
        <Modal show={show} onHide={onHide} aria-labelledby="delete-equipment-title">
            <Modal.Header closeButton>
                <Modal.Title id="delete-equipment-title">Delete equipment</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Are you sure you want to delete <strong>{equipment?.name}</strong> equipment?
                </p>
            </Modal.Body>
            <Modal.Footer>
                <SubmitButton
                    onClick={() => deleteEquipment(equipment?.equipid)}
                    isSubmitting={isSubmitting}
                    variant="primary"
                    spinnerText="Is Deleting..."
                >
                    Yes
                </SubmitButton>
                <Button onClick={onHide} variant="secondary">
                    No
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
